import { ApiClientConfiguration } from "./ApiClientConfiguration";
import { RequestInit } from "aurelia-fetch-client";

export class ApiClientBase {
  constructor(protected configuration: ApiClientConfiguration) {
  }

  protected getBaseUrl(defaultUrl: string, baseUrl: string): string {
    return this.configuration.basePath + defaultUrl + baseUrl;
  }

  protected async transformOptions(options: RequestInit): Promise<RequestInit> {
    const token = await this.configuration.auth.getApiTokenSilently();
    options.headers['Authorization'] = `Bearer ${token.accessToken}`;
    return options;
  }

  protected async transformResult(url: string, response: Response, processResponse: (response: Response) => Promise<any>): Promise<any> {
    return processResponse(response);
  }
}
